import { Checkout } from '../types/checkout';
import { getConfig } from './get-config';

type StripeCheckoutContext = Pick<Checkout, 'stripeAccountCountry'> | null | undefined;

export const getStripePublicKey = (checkout?: StripeCheckoutContext): string => {
  if (checkout?.stripeAccountCountry === 'BR') {
    return getConfig('REACT_APP_STRIPE_PUBLIC_KEY_BRL') ?? '';
  }

  return getConfig('REACT_APP_STRIPE_PUBLIC_KEY') ?? '';
};
